var $jAt6e$swchelperscjs_assert_this_initializedcjs = require("@swc/helpers/cjs/_assert_this_initialized.cjs");
var $jAt6e$swchelperscjs_class_call_checkcjs = require("@swc/helpers/cjs/_class_call_check.cjs");
var $jAt6e$swchelperscjs_create_classcjs = require("@swc/helpers/cjs/_create_class.cjs");
var $jAt6e$swchelperscjs_getcjs = require("@swc/helpers/cjs/_get.cjs");
var $jAt6e$swchelperscjs_get_prototype_ofcjs = require("@swc/helpers/cjs/_get_prototype_of.cjs");
var $jAt6e$swchelperscjs_inheritscjs = require("@swc/helpers/cjs/_inherits.cjs");
var $jAt6e$swchelperscjs_object_destructuring_emptycjs = require("@swc/helpers/cjs/_object_destructuring_empty.cjs");
var $jAt6e$swchelperscjs_create_supercjs = require("@swc/helpers/cjs/_create_super.cjs");
var $jAt6e$lodashisequalwith = require("lodash.isequalwith");
var $jAt6e$mobx = require("mobx");
var $jAt6e$react = require("react");


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $0172b398bee57f0a$exports = {};

$parcel$export($0172b398bee57f0a$exports, "isEqualProps", function () { return $0172b398bee57f0a$export$7112c88e033533b8; });
$parcel$export($0172b398bee57f0a$exports, "observePropsState", function () { return $0172b398bee57f0a$export$f337fa11e4ffe0c9; });










var $0172b398bee57f0a$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $0172b398bee57f0a$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $0172b398bee57f0a$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $0172b398bee57f0a$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $0172b398bee57f0a$export$7112c88e033533b8 = function(a, b) {
    return (0, ($parcel$interopDefault($jAt6e$lodashisequalwith)))(a, b, function(a, b, key) {
        return [
            "_owner",
            "$$typeof"
        ].includes(key) || undefined;
    });
};
function $0172b398bee57f0a$export$f337fa11e4ffe0c9(ComponentBaseClass, param) {
    var ref = (0, $jAt6e$swchelperscjs_object_destructuring_emptycjs._)(param);
    var ObservedComponent = function() {
        var _a, _ObservedComponent_observedProps_accessor_storage, _ObservedComponent_observedState_accessor_storage;
        var _classSuper = ComponentBaseClass;
        var _instanceExtraInitializers = [];
        var _observedProps_decorators;
        var _observedProps_initializers = [];
        var _observedState_decorators;
        var _observedState_initializers = [];
        return _a = /*#__PURE__*/ function(_classSuper) {
            "use strict";
            (0, $jAt6e$swchelperscjs_inheritscjs._)(ObservedComponent, _classSuper);
            var _super = (0, $jAt6e$swchelperscjs_create_supercjs._)(ObservedComponent);
            function ObservedComponent() {
                (0, $jAt6e$swchelperscjs_class_call_checkcjs._)(this, ObservedComponent);
                var _this;
                _this = _super.call.apply(_super, [
                    this
                ].concat(Array.prototype.slice.call(arguments)));
                _ObservedComponent_observedProps_accessor_storage.set((0, $jAt6e$swchelperscjs_assert_this_initializedcjs._)(_this), ($0172b398bee57f0a$var$__runInitializers((0, $jAt6e$swchelperscjs_assert_this_initializedcjs._)(_this), _instanceExtraInitializers), $0172b398bee57f0a$var$__runInitializers((0, $jAt6e$swchelperscjs_assert_this_initializedcjs._)(_this), _observedProps_initializers, _this.props)));
                _ObservedComponent_observedState_accessor_storage.set((0, $jAt6e$swchelperscjs_assert_this_initializedcjs._)(_this), $0172b398bee57f0a$var$__runInitializers((0, $jAt6e$swchelperscjs_assert_this_initializedcjs._)(_this), _observedState_initializers, {}));
                return _this;
            }
            (0, $jAt6e$swchelperscjs_create_classcjs._)(ObservedComponent, [
                {
                    key: "observedProps",
                    get: function get() {
                        return $0172b398bee57f0a$var$__classPrivateFieldGet(this, _ObservedComponent_observedProps_accessor_storage, "f");
                    },
                    set: function set(value) {
                        $0172b398bee57f0a$var$__classPrivateFieldSet(this, _ObservedComponent_observedProps_accessor_storage, value, "f");
                    }
                },
                {
                    key: "observedState",
                    get: function get() {
                        return $0172b398bee57f0a$var$__classPrivateFieldGet(this, _ObservedComponent_observedState_accessor_storage, "f");
                    },
                    set: function set(value) {
                        $0172b398bee57f0a$var$__classPrivateFieldSet(this, _ObservedComponent_observedState_accessor_storage, value, "f");
                    }
                },
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        var _b;
                        this.observedProps = this.props;
                        this.observedState = this.state;
                        (_b = (0, $jAt6e$swchelperscjs_getcjs._)((0, $jAt6e$swchelperscjs_get_prototype_ofcjs._)(ObservedComponent.prototype), "componentDidMount", this)) === null || _b === void 0 || _b.call(this);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function componentDidUpdate(prevProps, prevState, snapshot) {
                        var _b;
                        if (!$0172b398bee57f0a$export$7112c88e033533b8(prevProps, this.props)) this.observedProps = this.props;
                        if (!$0172b398bee57f0a$export$7112c88e033533b8(prevState, this.state)) this.observedState = this.state;
                        (_b = (0, $jAt6e$swchelperscjs_getcjs._)((0, $jAt6e$swchelperscjs_get_prototype_ofcjs._)(ObservedComponent.prototype), "componentDidUpdate", this)) === null || _b === void 0 || _b.call(this, prevProps, prevState, snapshot);
                    }
                }
            ]);
            return ObservedComponent;
        }(_classSuper), _ObservedComponent_observedProps_accessor_storage = new WeakMap(), _ObservedComponent_observedState_accessor_storage = new WeakMap(), function() {
            var _b;
            var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _observedProps_decorators = [
                (0, $jAt6e$mobx.observable)
            ];
            _observedState_decorators = [
                (0, $jAt6e$mobx.observable)
            ];
            $0172b398bee57f0a$var$__esDecorate(_a, null, _observedProps_decorators, {
                kind: "accessor",
                name: "observedProps",
                static: false,
                private: false,
                access: {
                    has: function(obj) {
                        return "observedProps" in obj;
                    },
                    get: function(obj) {
                        return obj.observedProps;
                    },
                    set: function(obj, value) {
                        obj.observedProps = value;
                    }
                },
                metadata: _metadata
            }, _observedProps_initializers, _instanceExtraInitializers);
            $0172b398bee57f0a$var$__esDecorate(_a, null, _observedState_decorators, {
                kind: "accessor",
                name: "observedState",
                static: false,
                private: false,
                access: {
                    has: function(obj) {
                        return "observedState" in obj;
                    },
                    get: function(obj) {
                        return obj.observedState;
                    },
                    set: function(obj, value) {
                        obj.observedState = value;
                    }
                },
                metadata: _metadata
            }, _observedState_initializers, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        }(), _a;
    }();
    return ObservedComponent;
}


var $621b7277d4dc39e9$exports = {};

$parcel$export($621b7277d4dc39e9$exports, "FormComponent", function () { return $621b7277d4dc39e9$export$cec7cafc710f5d68; });







var $621b7277d4dc39e9$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $621b7277d4dc39e9$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $621b7277d4dc39e9$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $621b7277d4dc39e9$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
/**
 * @example
 * ```tsx
 * import { ChangeEvent } from 'react';
 * import { observer } from 'mobx-react';
 * import { FormComponent, observePropsState } from 'mobx-react-helper';
 *
 * @observer
 * @observePropsState
 * export class MyField extends FormComponent {
 *     handleChange = ({ currentTarget: { value } }: ChangeEvent<HTMLInputElement>) => {
 *         this.innerValue = value;
 *
 *         this.props.onChange?.(this.innerValue);
 *     };
 *
 *     render() {
 *         const { onChange, ...props } = this.props,
 *             { value, handleChange } = this;
 *
 *         return <>
 *             <input {...props} onChange={handleChange} />
 *
 *             <output>{value}</output>
 *         </>;
 *     }
 * }
 * ```
 */ var $621b7277d4dc39e9$export$cec7cafc710f5d68 = function() {
    var _a, _FormComponent_innerValue_accessor_storage;
    var _classSuper = (0, $jAt6e$react.Component);
    var _instanceExtraInitializers = [];
    var _innerValue_decorators;
    var _innerValue_initializers = [];
    var _get_value_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $jAt6e$swchelperscjs_inheritscjs._)(FormComponent, _classSuper);
        var _super = (0, $jAt6e$swchelperscjs_create_supercjs._)(FormComponent);
        function FormComponent() {
            (0, $jAt6e$swchelperscjs_class_call_checkcjs._)(this, FormComponent);
            var _this;
            _this = _super.call.apply(_super, [
                this
            ].concat(Array.prototype.slice.call(arguments)));
            Object.defineProperty((0, $jAt6e$swchelperscjs_assert_this_initializedcjs._)(_this), "ref", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($621b7277d4dc39e9$var$__runInitializers((0, $jAt6e$swchelperscjs_assert_this_initializedcjs._)(_this), _instanceExtraInitializers), /*#__PURE__*/ (0, $jAt6e$react.createRef)())
            });
            _FormComponent_innerValue_accessor_storage.set((0, $jAt6e$swchelperscjs_assert_this_initializedcjs._)(_this), $621b7277d4dc39e9$var$__runInitializers((0, $jAt6e$swchelperscjs_assert_this_initializedcjs._)(_this), _innerValue_initializers, _this.props.defaultValue));
            Object.defineProperty((0, $jAt6e$swchelperscjs_assert_this_initializedcjs._)(_this), "reset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    var _b, _c;
                    _this.innerValue = _this.props.defaultValue;
                    (_c = (_b = _this.props).onChange) === null || _c === void 0 || _c.call(_b, _this.innerValue);
                }
            });
            return _this;
        }
        (0, $jAt6e$swchelperscjs_create_classcjs._)(FormComponent, [
            {
                key: "innerValue",
                get: function get() {
                    return $621b7277d4dc39e9$var$__classPrivateFieldGet(this, _FormComponent_innerValue_accessor_storage, "f");
                },
                set: function set(value) {
                    $621b7277d4dc39e9$var$__classPrivateFieldSet(this, _FormComponent_innerValue_accessor_storage, value, "f");
                }
            },
            {
                key: "value",
                get: function get() {
                    var _b;
                    return (_b = this.observedProps.value) !== null && _b !== void 0 ? _b : this.innerValue;
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _b, _c;
                    (_c = (_b = this.ref.current) === null || _b === void 0 ? void 0 : _b.form) === null || _c === void 0 || _c.addEventListener("reset", this.reset);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _b, _c;
                    (_c = (_b = this.ref.current) === null || _b === void 0 ? void 0 : _b.form) === null || _c === void 0 || _c.removeEventListener("reset", this.reset);
                }
            }
        ]);
        return FormComponent;
    }(_classSuper), _FormComponent_innerValue_accessor_storage = new WeakMap(), function() {
        var _b;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _innerValue_decorators = [
            (0, $jAt6e$mobx.observable)
        ];
        _get_value_decorators = [
            (0, $jAt6e$mobx.computed)
        ];
        $621b7277d4dc39e9$var$__esDecorate(_a, null, _innerValue_decorators, {
            kind: "accessor",
            name: "innerValue",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "innerValue" in obj;
                },
                get: function(obj) {
                    return obj.innerValue;
                },
                set: function(obj, value) {
                    obj.innerValue = value;
                }
            },
            metadata: _metadata
        }, _innerValue_initializers, _instanceExtraInitializers);
        $621b7277d4dc39e9$var$__esDecorate(_a, null, _get_value_decorators, {
            kind: "getter",
            name: "value",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "value" in obj;
                },
                get: function(obj) {
                    return obj.value;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();


$parcel$exportWildcard(module.exports, $0172b398bee57f0a$exports);
$parcel$exportWildcard(module.exports, $621b7277d4dc39e9$exports);


//# sourceMappingURL=index.js.map
